/* eslint-disable no-useless-escape */
import { phone as phoneValidate } from 'phone';
import { i18n } from '../lang';
import { PhoneNumberUtil } from 'google-libphonenumber';

const REQUIRED_TEXT_TID = 'VALIDATION.REQUIRED';

export const getError = (tid: string, values = {}) =>
  i18n.t && i18n.t(tid, values);

export const length = (length: number) => (value: any) => {
  if (String(value).length !== length) {
    return getError('VALIDATION.LENGTH', { length });
  }

  return null;
};

export const minLength = (min: number) => (value: number) => {
  if (String(value).length < min) {
    return getError('VALIDATION.MIN_LENGTH', { min });
  }

  return null;
};
//
export const maxLength =
  (max: number) =>
  (value = '') => {
    if (String(value).length > max) {
      return getError('VALIDATION.MAX_LENGTH', { max });
    }

    return null;
  };

export const minValue = (min: number) => (value: number) => {
  if (value < min) {
    return getError('VALIDATION.MIN_LENGTH', { min });
  }

  return null;
};
//
export const maxValue = (max: number) => (value: number) => {
  if (value > max) {
    return getError('VALIDATION.MAX_LENGTH', { max });
  }

  return null;
};
//
// export const hasLetter = (value) => /[A-Za-z]/.test(value);
// export const hasUpperCaseLetter = (value) => /[A-Z]/.test(value);
// export const hasLowerCaseLetter = (value) => /[a-z]/.test(value);
//
// export const hasSymbol = (value) => /[!@#$%^&*()_+?\-=]/.test(value);
//
// eslint-disable-next-line max-len
const EMAIL_EXP =
  /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/;
export const email = (value: any) => {
  if (value) {
    return !EMAIL_EXP.test(value) ? getError('VALIDATION.EMAIL') : null;
  }
};
//
// // eslint-disable-next-line max-len
const PASSWORD_EXP = /^(?=.*\d)(?!.*[а-яА-ЯёЁ])(?=\S+$).{8,}$/;
export const password = (value: string) => {
  if (value.trim()) {
    return !PASSWORD_EXP.test(value.trim())
      ? getError('VALIDATION.PASSWORD')
      : null;
  }
};
//
// // eslint-disable-next-line max-len
// const LOGIN_EXP = /^[A-z0-9_]{3,16}$/;
// export const login = (value) =>
//   !LOGIN_EXP.test(value) ? getError('VALIDATION.LOGIN') : null;

export const boolean = (value: any) =>
  !!value === false ? getError('VALIDATION.BOOLEAN') : null;

// // eslint-disable-next-line max-len
// const COMPANY_NAME_EXP = /^[а-яА-Я]+(([',. -][а-яА-Я ])?[а-яА-Я]*)*$/;
// export const companyName = (value) =>
//   !COMPANY_NAME_EXP.test(value) ? getError('VALIDATION.COMPANY_NAME') : null;
//
// // eslint-disable-next-line max-len
// const FIRST_NAME_EXP = /^[а-яА-Я]+(([',. -][а-яА-Я ])?[а-яА-Я]*)*$/;
// export const firstName = (value) =>
//   !FIRST_NAME_EXP.test(value) ? getError('VALIDATION.FIRST_NAME') : null;
//
// // eslint-disable-next-line max-len
// const LAST_NAME_EXP = /^[а-яА-Я]+(([',. -][а-яА-Я ])?[а-яА-Я]*)*$/;
// export const lastname = (value) =>
//   !LAST_NAME_EXP.test(value) ? getError('VALIDATION.LAST_NAME') : null;
//
// eslint-disable-next-line max-len

const phoneUtil = PhoneNumberUtil.getInstance();

export const phone = (value: any) => {
  if (value && !phoneValidate(value).isValid) {
    return getError('VALIDATION.PHONE');
  }
  return null;
};

const PHONE_UA_EXP = /^\+?3?8?(0\d{9})$/;
export const phoneUA = (value: any) => {
  if (!PHONE_UA_EXP.test(value) && value) {
    return getError('VALIDATION.PHONE');
  }
  return null;
};

const USER_NAME_EXP =
  /^[a-zA-Zа-яА-ЯёЁіІїЇєЄґҐ]+( [a-zA-Zа-яА-ЯёЁіІїЇєЄґҐ]+)*$/;
export const userName = (value: any) => {
  if (!NAME_EXP.test(value?.trim()) && value && !value.trim()) {
    return getError('VALIDATION.NAME');
  }
  return null;
};

const NAME_EXP =
  /^(?=.*[A-Za-zА-Яа-яЁёІіЇїЄєҐґ])[\dA-Za-zА-Яа-яЁёІіЇїЄєҐґ\s.,!?'"(){}[\]<>:;*+=_-]+$/;
export const name = (value: any) => {
  if (!NAME_EXP.test(value?.trim()) && value && !value.trim()) {
    console.log('error validation');
    return getError('VALIDATION.NAME');
  }
  return null;
};

export const number = (value: any) => {
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(parseFloat(value)) && value) {
    return getError('VALIDATION.NUMBER');
  }

  return null;
};

export const moreThanTime =
  (startField: string) => (value: string, values: any) => {
    const startTime = values[startField];
    const endTime = value;
    console.log(startTime, endTime);
    if (startTime && endTime) {
      // Преобразуем время в секунды
      const [startHours, startMinutes, startSeconds] = startTime
        .split(':')
        .map(Number);
      const [endHours, endMinutes, endSeconds] = endTime.split(':').map(Number);

      const startInSeconds =
        startHours * 3600 + startMinutes * 60 + (startSeconds || 0);
      const endInSeconds =
        endHours * 3600 + endMinutes * 60 + (endSeconds || 0);

      console.log(startInSeconds, endInSeconds);

      // Проверяем условие "startTime < endTime"
      if (startInSeconds >= endInSeconds) {
        return `Time must be greater than ${startTime}`; // Сообщение об ошибке
      }
    }

    return null; // Нет ошибок
  };
export const lessThanTime =
  (startField: string) => (value: string, values: any) => {
    const startTime = values[startField];
    const endTime = value;
    console.log(startTime, endTime);
    if (startTime && endTime) {
      // Преобразуем время в секунды
      const [startHours, startMinutes, startSeconds] = startTime
        .split(':')
        .map(Number);
      const [endHours, endMinutes, endSeconds] = endTime.split(':').map(Number);

      const startInSeconds =
        startHours * 3600 + startMinutes * 60 + (startSeconds || 0);
      const endInSeconds =
        endHours * 3600 + endMinutes * 60 + (endSeconds || 0);

      console.log(startInSeconds, endInSeconds);

      // Проверяем условие "startTime < endTime"
      if (startInSeconds <= endInSeconds) {
        return `Time must be less than ${startTime}`; // Сообщение об ошибке
      }
    }

    return null; // Нет ошибок
  };

export const lessThan =
  (startField: string) => (value: string, values: any) => {
    const start = values[startField];
    const end = value;
    if (start && end) {
      if (Number(start) <= Number(end)) {
        return `Must be less than ${start}`; // Сообщение об ошибке
      }
    }

    return null; // Нет ошибок
  };

export const moreThan =
  (startField: string) => (value: string, values: any) => {
    const start = values[startField];
    const end = value;
    if (start && end) {
      if (Number(start) >= Number(end)) {
        return `Must be more than ${start}`; // Сообщение об ошибке
      }
    }

    return null; // Нет ошибок
  };

const PHONES_OPERATORS = [
  '066',
  '067',
  '068',
  '091',
  '096',
  '097',
  '098',
  '063',
  '093',
  '073',
  '050',
  '095',
  '099',
];
export const phoneOperator = (value: string) => {
  if (!PHONES_OPERATORS.includes(value.slice(3, 6)) && value) {
    return getError('VALIDATION.PHONE_OPERATOR');
  }
  return null;
};

//
// export const numberPositive = (value) => {
//   const val = parseFloat(value);
//   // eslint-disable-next-line no-restricted-globals
//   if (isNaN(val) || val < 0) {
//     return getError('VALIDATION.NUMBER_POSITIVE');
//   }
//
//   return null;
// };
//
export const numberPositiveMin = (min: number) => (value: number) => {
  // const val = parseFloat(value);

  if (value < min && value) {
    return getError('VALIDATION.NUMBER_POSITIVE_MIN', { min });
  }

  return null;
};
//
// export const numberPositiveMax = (max) => (value) => {
//   const val = parseFloat(value);
//
//   if (val > max) {
//     return getError('VALIDATION.NUMBER_POSITIVE_MAX', { max });
//   }
//
//   return null;
// };
//
export const required = (value: any) => {
  if (!value) {
    return getError(REQUIRED_TEXT_TID);
  }

  if (!String(value).trim()) {
    return getError(REQUIRED_TEXT_TID);
  }

  return null;
};

export const balanceAmount = (max: number) => (value: string) => {
  const val = parseFloat(value);

  if (val > max) {
    return getError('VALIDATION.BALANCE', { max });
  }

  return null;
};

export const requiredArray = (value = []) => {
  if (value.length === 0) {
    return getError(REQUIRED_TEXT_TID);
  }

  return null;
};
//
// const ARRAY_LENGTH_MAX_TID = 'VALIDATION.ARRAY_LENGTH_MAX';
//
// export const arrayLengthMax =
//   (length) =>
//   (value = []) => {
//     if (value.length > length) {
//       return getError(ARRAY_LENGTH_MAX_TID, { length });
//     }
//
//     return null;
//   };
//
// // eslint-disable-next-line max-len
// const URL_EXP = /^[A-z0-9-]{3,100}$/;
// export const url = (value) =>
//   !URL_EXP.test(value) ? getError('VALIDATION.NOT_URL') : null;
//
export const passwordRepeat = (field: string) => (value: any, values: any) => {
  if (value !== values[field]) {
    return getError('VALIDATION.PASSWORD_REPEAT');
  }

  return null;
};

// export const fieldMatch = (field, tid) => (value, values) => {
//   if (value === values[field]) {
//     return getError(tid);
//   }
//
//   return null;
// };
//
// export const emailRepeat = (field) => (value, values) => {
//   if (value !== values[field]) {
//     return getError('VALIDATION.EMAIL_REPEAT');
//   }
//
//   return null;
// };

export const requiredIfEqual =
  (field: string, fieldValue: any) => (value: any, values: any) => {
    if (values[field] === fieldValue) {
      if (!value) {
        return getError(REQUIRED_TEXT_TID);
      }
    }

    return null;
  };

export const requiredIfAllEqual =
  (conditions: [field: string, value: any][]) => (value: any, values: any) => {
    const allMatch = conditions.every(
      ([field, expectedValue]) => values[field] === expectedValue,
    );

    if (allMatch && !value) {
      return getError(REQUIRED_TEXT_TID);
    }

    return null;
  };

export const requiredArrayIfEqual =
  (field: string, fieldValue: any) => (value: any, values: any) => {
    if (values[field] === fieldValue) {
      if (!value?.length) {
        return getError(REQUIRED_TEXT_TID);
      }
    }

    return null;
  };

export const requiredIfArray = (field: string) => (value: any, values: any) => {
  console.log(values[field], value, 'formik.values');
  if (values[field]?.length === 0 && value) {
    console.log('&& value', 'formik.values');

    return null;
  }
  if (values[field]?.length > 0) {
    console.log('values[field]?.length > 0', 'formik.values');
    return null;
  }
  return getError(REQUIRED_TEXT_TID);
};

export const requiredIfNotEqual =
  (field: string, fieldValue: any) => (value: any, values: any) => {
    if (values[field] !== fieldValue) {
      if (!value) {
        return getError(REQUIRED_TEXT_TID);
      }
    }

    return null;
  };
